import { Divider, IconButton } from "@mui/material/node";
import AddIcon from '@mui/icons-material/Add';
import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { NewNodeDialog } from '../../Dialogs/newNodeDialog';
import { useState, useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { ProjectContext } from '../../../contexts/ProjectContext';
import { DeleteElementDialog } from "../../Dialogs/deleteElementDialog";
import { NewSimpleNodeDialog } from "../../Dialogs/newSimpleNodeDialog";

export const AddButton = (props) => {

    const [showNewNodeDialog, setShowNewNodeDialog] = useState(false);
    const [showDeleteNodeDialog, setShowDeleteNodeDialog] = useState(false);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [newNodeType, setNewNodeType] = useState("O");
    const theme = useTheme();

    const { startConnection, deleteElement } = useContext(ProjectContext);


    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleAddNode = () => {
        setNewNodeType("O");
        setShowNewNodeDialog(true)
        setAnchorElUser(null);
    };

    const handleAddParentNode = () => {
        setNewNodeType("PARENT");
        setShowNewNodeDialog(true)
        setAnchorElUser(null);
    };

    const handleAddConnection = () => {
        startConnection()
        setAnchorElUser(null);
    };

    const handleDeleteElement = () => {
        setAnchorElUser(null);
        setShowDeleteNodeDialog(true);
    }

    if (!props.selectedItem || props.selectedItem === -1) {
        return (
            <>
                <IconButton aria-label="Refresh layout" onClick={handleOpenUserMenu} color="inherit" sx={{ m: 0.5 }}>
                    <Tooltip title="Add">
                    <AddIcon sx={{color: theme.palette.menuIcon.main}} />
                    </Tooltip>
                </IconButton>
                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    <MenuItem key="myprojects" onClick={handleAddNode}>
                        <Typography textAlign="center">Add node</Typography>
                    </MenuItem>
                </Menu>
                {/* <NewNodeDialog open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} nodetype={newNodeType}/> */}
                <NewSimpleNodeDialog open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} nodetype={newNodeType}/>
            </>
        );
    }

    if (props.selectedItem) {
        return (
            <>
                <IconButton aria-label="Refresh layout" onClick={handleOpenUserMenu} color="inherit" sx={{ m: 0.5 }}>
                    <AddIcon sx={{color: theme.palette.menuIcon.main}} />
                </IconButton>
                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    <MenuItem key="myprojects" onClick={handleAddParentNode}>
                        <Typography textAlign="center">Add node</Typography>
                    </MenuItem>
                    <MenuItem key="profile" onClick={handleAddConnection}>
                        <Typography textAlign="center">Add connection</Typography>
                    </MenuItem>
                    <Divider />
                    <MenuItem key="logout" onClick={handleDeleteElement}>
                        <Typography textAlign="center">Delete</Typography>
                    </MenuItem>
                </Menu>
                {/* <NewNodeDialog open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} nodetype={newNodeType}/> */}
                <NewSimpleNodeDialog open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} nodetype={newNodeType}/>
                <DeleteElementDialog open={showDeleteNodeDialog} handleClose={() => setShowDeleteNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} />
            </>
        );
    }
}
